var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"stripe":"","load-data":_vm.loadData,"row-key":_vm.rowKey,"columns":_vm.realColumns,"data":_vm.data},on:{"on-selection-change":function (selection) { return _vm.$emit('onSelect', selection); }},scopedSlots:_vm._u([{key:"index",fn:function(ref){
var index = ref.index;
return (_vm.indexVisible)?[_vm._v(" "+_vm._s(_vm.calcIndex(index))+" ")]:undefined}},_vm._l((_vm.slotsName),function(slotName){return {key:slotName,fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._t(slotName,null,{"row":row,"index":index})]}}})],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }